var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ASelectInput',_vm._g(_vm._b({attrs:{"item-text":_vm.itemText,"item-value":"id","label":_vm.label,"model":_vm.model,"placeholder":_vm.placeholder}},'ASelectInput',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }